import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';

const CandidateFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [citizenshipOptions, setCitizenshipOptions] = useState([]);
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const payload = {
    first_name: formData.first_name ?? '',
    last_name: formData.last_name ?? '',
    name: formData.name ?? '',
    email: formData.email ?? '',
    active: !!formData.active,
    approved: !!formData.approved,
    general_registration: !!formData.general_registration,
    citizenship: formData.citizenship ?? null,
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().candidateId) || (entity === 'candidate' && id)) {
      apiCall('patch', '/api/v2/candidate/' + (window.App.urlVars().candidateId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateList: Math.random()})
          window.App.setState({ rerenderCandidateShow: Math.random() });
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/candidate', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/recruitment/candidate/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', `/api/v2/citizenship/` )
      .then(response => {
        setCitizenshipOptions(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    if ((!window.App.urlVars().create && window.App.urlVars().candidateId) || (entity === 'candidate' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/candidate/' + (window.App.urlVars().candidateId ?? id))
        .then(response => {
          setFormData({
            ...response.data.data,
            citizenship: response.data.data.citizenship.id || null
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"candidate-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="first_name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="first_name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLastName')}</label>
                  <span className="p-d-block">
                      <InputText id="first_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     first_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     first_name: e.target.value
                                   })
                                 }}
                                 value={formData.first_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="last_name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="last_name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFirstName')}</label>
                  <span className="p-d-block">
                      <InputText id="last_name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     last_name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     last_name: e.target.value
                                   })
                                 }}
                                 value={formData.last_name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmail')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     email: e.target.value
                                   })
                                 }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="citizenship" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="citizenship"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCitizen')}</label>
                  <span className="p-d-block">
                      <Dropdown id="citizenship" {...input}
                                  options={window.App.sortDropdownOptions(citizenshipOptions, "name")}
                                 value={input.value}
                                  optionLabel="name"
                                  optionValue='id'
                                 onChange={(e) => {
                                  input.onChange(e.value);  
                                   setFormData({
                                     ...formData,
                                     citizenship: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     citizenship: e.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>

            </div>


            <div className={"p-col-12 p-lg-3"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <span className="p-d-block">
                      <Checkbox id="active" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     active: !!e.checked
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     active: !!e.checked
                                   })
                                 }}
                                 checked={formData.active}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-3"}>
              <Field name="approved" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="approved"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('REVIEWED')}</label>
                  <span className="p-d-block">
                      <Checkbox id="approved" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     approved: !!e.checked
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     approved: !!e.checked
                                   })
                                 }}
                                 checked={formData.approved}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            


            <div className={"p-col-12 p-lg-3"}>
              <Field name="general_registration" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="general_registration"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldGeneralRegistration')}</label>
                  <span className="p-d-block">
                      <Checkbox id="general_registration" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     general_registration: !!e.checked
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     general_registration: !!e.checked
                                   })
                                 }}
                                 checked={formData.general_registration}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'candidate' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CandidateFormComponent);
